<form *ngIf="form" [formGroup]="form" (ngSubmit)="confirm(form)">
	<div class="main">
        <div>
            <b i18n class="required">Комментарий:</b>
            <app-textarea formControlName="message" maxLength="1000" name="{{ getFieldTranslate('comment') }}" [rows]="3"></app-textarea>
        </div>
        <div>
            <b i18n class="required">Логин:</b>
            <app-textbox formControlName="login" isDisabled=true></app-textbox>
        </div>
        <div>
            <b i18n class="required">Пароль:</b>
            <app-passwordbox formControlName="password" name="{{ getFieldTranslate('password') }}" [noTrimValue]="true"></app-passwordbox>
        </div>
	</div>
	<footer>
		<button i18n class="save" appSkin="action-save bold">ОК</button>
		<button i18n type="button" class="save" appSkin="simple no-shadow bold bordered" (click)="close()">Закрыть</button>
	</footer>
</form>
